
        import V from 'voUtils/V.js';
        import Vue from 'vue';
        import {voMsg,voMsgPl} from './voUtils/voI18n.js';
        import DateEx from './voUtils/DateEx.js';

        Vue.prototype.VOFFICE = window.VOFFICE;

        var voFormatDate = DateEx.formatDate;

        import AirbnbStyleDatepicker from 'base/vue-airbnb-style-datepicker'
        import 'base/vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css'

        var vueApps = {};

        var methods = {voMsg,voMsgPl,voFormatDate};

        
            import App0 from './app/navbar.js';
            vueApps['app/navbar.js'] = App0;
        

            import App1 from './app/dummy.js';
            vueApps['app/dummy.js'] = App1;
        

            import App2 from './FacilityUnit.js';
            vueApps['FacilityUnit.js'] = App2;
        

            import App3 from './app/unit.js';
            vueApps['app/unit.js'] = App3;
        

            import App4 from './app/search.js';
            vueApps['app/search.js'] = App4;
        

            import App5 from './unitsOfTheDay.js';
            vueApps['unitsOfTheDay.js'] = App5;
        

            import App6 from './app/SimilarUnits.js';
            vueApps['app/SimilarUnits.js'] = App6;
        

            import App7 from './app/facilitylisting.js';
            vueApps['app/facilitylisting.js'] = App7;
        

            import App8 from './app/LastViewedUnits.js';
            vueApps['app/LastViewedUnits.js'] = App8;
        

            import App9 from './app/lueckenbuchen.js';
            vueApps['app/lueckenbuchen.js'] = App9;
        

            import App10 from './app/veranstaltungen.js';
            vueApps['app/veranstaltungen.js'] = App10;
        

        
                import Comp11 from './IncreaseNumber.vue';
                Vue.component('increase-number',Comp11);
            

                import Comp12 from './comp/DateRange.vue';
                Vue.component('voffice-daterange',Comp12);
            

                import Comp13 from './comp/GuestBox.vue';
                Vue.component('voffice-guestbox',Comp13);
            

                import Comp14 from './comp/childrenage.vue';
                Vue.component('childrenage',Comp14);
            

                import Comp15 from './comp/ErrorMessage.vue';
                Vue.component('voffice-error-message',Comp15);
            

                import Comp16 from './comp/openstreetmap.vue';
                Vue.component('voffice-openstreetmap',Comp16);
            

                import Comp17 from './comp/gmap.js';
                Vue.component('voffice-gmap',Comp17);
            

                import Comp18 from './comp/ImgFallback.vue';
                Vue.component('img-fallback',Comp18);
            

                import Comp19 from './comp/floorvalue.vue';
                Vue.component('floor-display',Comp19);
            

                import Comp20 from './comp/Voucher.vue';
                Vue.component('voffice-voucher',Comp20);
            

                import Comp21 from './comp/Booking.js';
                Vue.component('voffice-booking',Comp21);
            

                import Comp22 from './carousel.vue';
                Vue.component('owl-carousel',Comp22);
            

                import Comp23 from './comp/MaxTextSize.js';
                Vue.component('voffice-max-text-size',Comp23);
            

                import Comp24 from './comp/PhotoSwipe.js';
                Vue.component('voffice-photoswipe',Comp24);
            

                import Comp25 from './comp/FavElement.vue';
                Vue.component('voffice-fav-element',Comp25);
            

                import Comp26 from './pricelisthelp.vue';
                Vue.component('price-list-help',Comp26);
            

                import Comp27 from './comp/ContactForm.js';
                Vue.component('voffice-form',Comp27);
            

                import Comp28 from './comp/PopupBox.vue';
                Vue.component('voffice-popup-box',Comp28);
            

                import Comp29 from './comp/DateRangeExt.vue';
                Vue.component('voffice-daterange-ext',Comp29);
            

                import Comp30 from './comp/SearchFilterTokens.vue';
                Vue.component('search-filter-tokens',Comp30);
            

                import Comp31 from './ImageCarousel.vue';
                Vue.component('img-carousel',Comp31);
            

                import Comp32 from './comp/Paginate.vue';
                Vue.component('voffice-paginate',Comp32);
            

                import Comp33 from './pricehelp.vue';
                Vue.component('price-help',Comp33);
            

                import Comp34 from './comp/DocBox.vue';
                Vue.component('voffice-doc-box',Comp34);
            

                import Comp35 from './offershelp.vue';
                Vue.component('offer-help',Comp35);
            

                import Comp36 from './facilityimages.vue';
                Vue.component('facility-img-carousel',Comp36);
            

                import Comp37 from './facilityinfo.vue';
                Vue.component('facility-info',Comp37);
            

                import Comp38 from './facilityobjectsinfo.vue';
                Vue.component('facility-object-info',Comp38);
            

                import Comp39 from './NewsletterSubscription.js';
                Vue.component('voffice-newsletter-subscription',Comp39);
            

        Vue.mixin({
            methods: methods
        });

        const datepickerOptions = {
            days: voMsg('weekdayslist').split(','),
            daysShort: voMsg('weekdayslist.short').split(','),
            monthNames: voMsg('monthlist.full').split(',')
        };
        Vue.use(AirbnbStyleDatepicker, datepickerOptions);


    	var passThrough = function (val) {
			return val || '';
		};

    	var filterCodes = [
    	    'vlang',
    	    'vautolang',
    	    'vsoption',
    	    'vsPropOption'
    	  ];

        for (let fc of filterCodes) {
    		Vue.filter(fc, passThrough);
    	};


        var vueAppEls = document.body.querySelectorAll('[vo-vue-app]');

        for (let el of vueAppEls) {
            let vName = el.getAttribute("vo-vue-app");
            let v = vueApps[vName];
            if (v) {
                v.el = el;
                V.log("creating vue app",vName);

                let app = new Vue(v);
            }

        }

        VOFFICE.afterAllLoaded = function(){
            document.documentElement.classList.add("app-loaded");
        };

        window.addEventListener('beforeunload', function (event) {
        	document.documentElement.classList.add("app-leaving");
        });


    